import { FC, SVGProps } from 'react';

const LibidoIcon: FC<SVGProps<SVGElement>> = ({
  width = '194',
  height = '194',
}) => {
  return (
    <svg
      fill='none'
      height={height}
      viewBox='0 0 194 194'
      width={width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d_728_3504)'>
        <rect
          fill='#1F1E1E'
          height='121.129'
          transform='rotate(-45 11 97)'
          width='121.129'
          x='11'
          y='97'
        />
        <rect
          height='120.031'
          stroke='#009FAF'
          strokeWidth='1.09809'
          transform='rotate(-45 11.7765 97)'
          width='120.031'
          x='11.7765'
          y='97'
        />
      </g>
      <path
        d='M85.9493 91.1982C85.4646 91.1982 85.1414 91.6022 85.1414 92.0062C85.1414 92.491 85.5454 92.8141 85.9493 92.8141C93.3824 92.8141 99.442 98.8737 99.442 106.307C99.442 113.74 93.3824 119.799 85.9493 119.799C78.5163 119.799 72.4567 113.74 72.4567 106.307C72.4567 105.822 72.0527 105.499 71.6488 105.499C71.164 105.499 70.8408 105.903 70.8408 106.307C70.8408 114.629 77.6275 121.415 85.9493 121.415C94.2712 121.415 101.058 114.629 101.058 106.307C101.058 97.985 94.2712 91.1982 85.9493 91.1982Z'
        fill='#009FAF'
      />
      <path
        d='M124.004 72.6964C123.923 72.5349 123.843 72.2925 123.762 72.0501C123.681 71.8885 123.6 71.6461 123.519 71.4845C123.439 71.4037 123.358 71.2421 123.277 71.1614C123.196 70.9998 123.035 70.8382 122.873 70.6766C122.712 70.515 122.55 70.3534 122.469 70.2726C122.308 70.1918 122.227 70.0302 122.065 69.9494C121.904 69.8686 121.742 69.7878 121.5 69.6263C121.257 69.5455 121.096 69.4647 120.853 69.3839C120.611 69.3031 120.449 69.3031 120.126 69.2223C119.884 69.2223 119.722 69.2223 119.561 69.2223C119.48 69.2223 119.399 69.2223 119.318 69.2223C119.076 69.2223 118.914 69.2223 118.672 69.3031C118.51 69.3031 118.268 69.3839 118.106 69.4647L109.784 72.3733C108.573 72.7772 107.684 73.5852 107.118 74.7163C106.553 75.8474 106.472 77.0593 106.876 78.2712C106.957 78.5944 107.118 78.9176 107.28 79.2408L107.441 79.564L98.7156 88.2897L98.3924 88.0473C94.6759 85.5427 90.3938 84.1692 85.9501 84.1692C73.7502 84.1692 63.8125 94.1069 63.8125 106.307C63.8125 118.507 73.7502 128.444 85.9501 128.444C98.1501 128.444 108.088 118.507 108.088 106.307C108.088 102.51 107.118 98.7122 105.179 95.3996L105.098 95.0765L105.341 94.8341L114.067 86.1083L114.39 86.2699C114.713 86.4315 114.955 86.5931 115.278 86.6739C115.763 86.8354 116.248 86.9162 116.814 86.9162C117.541 86.9162 118.187 86.7546 118.833 86.4315C119.965 85.8659 120.772 84.8964 121.176 83.7653L123.923 75.4434C124.004 75.2819 124.004 75.0395 124.085 74.7971C124.166 74.5547 124.166 74.3931 124.166 74.1507C124.166 73.9084 124.166 73.666 124.166 73.4236C124.085 73.1812 124.085 72.9388 124.004 72.6964ZM122.469 74.6355C122.469 74.7163 122.469 74.8779 122.388 74.9587L119.561 83.2805C119.318 84.0076 118.753 84.654 118.025 84.9772C117.621 85.2196 117.137 85.3003 116.733 85.3003C116.41 85.3003 116.086 85.2196 115.763 85.1388C115.278 84.9772 114.874 84.7348 114.551 84.4116C114.39 84.25 114.228 84.1692 113.905 84.1692C113.743 84.1692 113.501 84.25 113.339 84.4116L104.129 93.6222C103.967 93.7837 103.725 93.9453 103.482 94.1069C103.321 94.1877 103.159 94.4301 103.079 94.5917C102.998 94.8341 103.079 95.0765 103.159 95.238C105.26 98.5506 106.391 102.348 106.391 106.226C106.391 117.537 97.1805 126.667 85.9501 126.667C74.6389 126.667 65.5092 117.456 65.5092 106.226C65.5092 94.9957 74.7197 85.7851 85.9501 85.7851C90.4746 85.7851 94.7567 87.2394 98.3116 89.9864C98.4732 90.0672 98.6348 90.148 98.7964 90.148C98.8772 90.148 98.8772 90.148 98.958 90.148C99.2004 90.148 99.362 89.9864 99.5236 89.8248C99.6044 89.6632 99.7659 89.5016 99.9275 89.3401L109.219 80.0487C109.38 79.8871 109.461 79.6447 109.461 79.4832C109.461 79.2408 109.38 79.0792 109.219 78.9176C108.896 78.5944 108.653 78.1905 108.492 77.7057C108.169 76.9785 108.169 76.1706 108.573 75.4434C108.896 74.7163 109.542 74.1507 110.269 73.9084L118.591 71.0806C118.672 71.0806 118.833 70.9998 118.995 70.9998C119.157 70.9998 119.237 70.919 119.399 70.919H119.561C119.641 70.919 119.803 70.919 119.965 70.919C120.126 70.919 120.288 70.9998 120.449 70.9998C120.611 70.9998 120.692 71.0806 120.934 71.1614C121.015 71.1614 121.096 71.2421 121.176 71.3229C121.257 71.3229 121.257 71.4037 121.419 71.4845C121.5 71.5653 121.661 71.6461 121.742 71.7269C121.823 71.8077 121.904 71.8885 122.065 72.0501C122.146 72.1309 122.146 72.2117 122.227 72.2117C122.308 72.2925 122.308 72.3733 122.388 72.6156C122.469 72.7772 122.469 72.858 122.55 73.0196C122.631 73.1812 122.631 73.3428 122.631 73.5044C122.631 73.666 122.631 73.8276 122.631 73.9892C122.469 74.3123 122.469 74.3931 122.469 74.6355Z'
        fill='#009FAF'
      />
      <defs>
        <filter
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
          height='193.264'
          id='filter0_d_728_3504'
          width='193.264'
          x='0.0190735'
          y='0.36795'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            result='hardAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='5.49046' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.054902 0 0 0 0 0.819608 0 0 0 0 0.984314 0 0 0 0.7 0'
          />
          <feBlend
            in2='BackgroundImageFix'
            mode='normal'
            result='effect1_dropShadow_728_3504'
          />
          <feBlend
            in='SourceGraphic'
            in2='effect1_dropShadow_728_3504'
            mode='normal'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
};

export default LibidoIcon;
